import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Iconify from '../../../../theme/iconify/iconify';

function SubsectionType({ open, setOpen, subsection, quiz }) {
    const { t } = useTranslation();

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Paper
                sx={{
                    padding: '24px',
                    minWidth: { xs: '95%', md: '35%' },
                    maxWidth: { xs: '95%', md: '35%' },
                }}
            >
                <Typography variant='h6'>
                    {t('course.modals.contentType.title')}
                </Typography>
                <Typography variant='body2' sx={{ mb: 4 }}>
                    {t('course.modals.contentType.subsection.description')}
                </Typography>
                <Stack>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Button
                                variant=''
                                onClick={() => {
                                    setOpen(false);
                                    subsection(true);
                                }}
                                className='mISLec_course_new_content_button'
                                sx={{
                                    borderRadius: '8px !important',
                                    minHeight: '140px',
                                    width: '100%',
                                    flexDirection: 'column',
                                    fontSize: '0.95rem',
                                    backgroundColor: (theme) => ({
                                        xs: alpha(theme.palette.primary.main, 0.08),
                                        md: 'rgba(33, 43, 54, 0.08)'
                                    }),
                                    color: {
                                        xs: 'primary.main',
                                        md: 'inherit'
                                    },
                                    '&:hover': {
                                        color: 'primary.main',
                                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08)
                                    }
                                }}
                            >
                                <Iconify icon='mingcute:content-ai-fill' width={40} />
                                {t('course.modals.contentType.subsection.subsection.title')}
                                <span style={{ display: 'block', fontWeight: '400', fontSize: '0.875rem', lineHeight: '1' }}>
                                    {t('course.modals.contentType.subsection.subsection.description')}
                                </span>
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant=''
                                onClick={() => {
                                    setOpen(false);
                                    quiz(true, false);
                                }}
                                className='mISLec_course_new_content_button'
                                sx={{
                                    borderRadius: '8px !important',
                                    minHeight: '140px',
                                    width: '100%',
                                    flexDirection: 'column',
                                    fontSize: '0.95rem',
                                    backgroundColor: (theme) => ({
                                        xs: alpha(theme.palette.primary.main, 0.08),
                                        md: 'rgba(33, 43, 54, 0.08)'
                                    }),
                                    color: {
                                        xs: 'primary.main',
                                        md: 'inherit'
                                    },
                                    '&:hover': {
                                        color: 'primary.main',
                                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08)
                                    }
                                }}
                            >
                                <Iconify icon='octicon:goal-16' width={40} />
                                {t('course.modals.contentType.subsection.quiz.title')}
                                <span style={{ display: 'block', fontWeight: '400', fontSize: '0.875rem', lineHeight: '1' }}>
                                    {t('course.modals.contentType.subsection.quiz.description')}
                                </span>
                            </Button>
                        </Grid>
                    </Grid>
                </Stack>
                <Stack
                    direction='row'
                    alignItems='center'
                    mt={4}
                    sx={{
                        justifyContent: 'flex-end'
                    }}
                >
                    <Button
                        variant=''
                        onClick={() => setOpen(false)}
                        sx={{
                            borderRadius: '8px !important',
                            backgroundColor: (theme) => ({
                                xs: alpha(theme.palette.error.main, 0.08),
                                md: 'rgba(33, 43, 54, 0.08)'
                            }),
                            color: {
                                xs: 'error.main',
                                md: 'inherit'
                            },
                            '&:hover': {
                                color: 'error.main',
                                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08)
                            }
                        }}
                    >
                        {t('course.modals.contentType.cancel')}
                    </Button>
                </Stack>
            </Paper>
        </Modal>
    );
}

export default SubsectionType;